import { Box, Button, Tooltip, Typography } from "@mui/material"
import { exportTanClientMyCas, getClientMycas, getIncomeTaxProfile, getTanClientsCredentials } from "api/services/automation/income-tax-tan";
import Table, { ColumnType } from "components/Table";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { useState } from "react";
import AccessDenied from "../../Access/accessDenide";
import Loader from "components/Loader";
import moment from "moment";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";



const TanClientMycas = (state) => {
  const params = useParams();
  const navigate = useNavigate()
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [checkAccess, setCheckAccess] = useState(true)

  const { data, isLoading }: ResType = useQuery(
    ["get-tan-client-my-cas", params.incometaxid, { limit: pageCount, offset: page * pageCount }],
    getClientMycas,
    {
      onSuccess: (res) => {
        // setCheckAccess(res?.data?.accessDenied)
        setTotalCount(res?.data?.count);
      },
    }
  );

  const { data:clientData, isLoading:isLoading1 }: ResType = useQuery(
    ["get-income-tax-tan-profile", params.incometaxid],
    getIncomeTaxProfile,
);
const clientName = clientData?.data?.profileDetails?.name;

const { mutate: mutate1 } = useMutation(exportTanClientMyCas, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = ` ATOM Pro - ${clientName} Income Tax Authorised CA ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Authorised CA exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    mutate1({
      ...state,
      incometaxid: params.incometaxid
    });
  };

  const columns: Array<ColumnType> = [
    {
      key: "id",
      title: "AY",
      render: (row: any) => {
        return (
          <Box>
            <Typography>{row?.assessmentYear ? `${row?.assessmentYear}` : "-"}</Typography>
          </Box>
        );
      },
    },
    {
      key: "caName",
      title: "CA Name",
    },
    {
      key: "caMembershipNum",
      title: "Membership #",
      render: (row: any) => {
        return (
          <Box>
            <Typography>{row?.caMembershipNum ? `${row?.caMembershipNum}` : "-"}</Typography>
          </Box>
        );
      },
    },
    {
      key: "filingType",
      title: "Filing Type",
      render: (row: any) => {
        return (
          <Typography>
            {row?.filingType === 'O'
              ? 'Original'
              : row?.filingType === 'R'
                ? 'Revised'
                : '-'}
          </Typography>
        )
      }
    },
    {
      key: "formTypeCd",
      title: "Form Type",
    },
    {
      key: "assignedDate",
      title: "Assigned Date",
      render: (row: any) => {
        return (
          <Typography>
            {row?.assignedDate ? moment(row?.assignedDate).format("MMM DD, YYYY") : "-"}
          </Typography>
        );
      },
    },
    {
      key: "transactionNo",
      title: "Transaction ID",
    },

    {
      key: "udinNumber",
      title: "UDIN",
      render: (row: any) => {
        return (
          <Typography>{row?.udinNumber ? row?.udinNumber : '-'}</Typography>
        )
      }
    },

  ];
  

  if (isLoading) return <Loader />
  return (
    <>
     <Box display="flex" justifyContent="flex-end" m={2}>
            <Button
                variant="outlined"
                color="secondary"
                onClick={handleExport}
                startIcon={<FileDownloadOutlinedIcon />}
            >
                Export
            </Button>
            </Box>
          <Box pl={1} pr={1}>
      {!checkAccess && (
        <AccessDenied />
      )}
      {checkAccess && (
        <Box>
          {data && data?.data.count > 0 ?
            <>
              <Table
                // selection={{ selected, setSelected }}
                pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
                data={data?.data?.result || []}
                columns={columns}
                loading={isLoading}
              />
            </> : <>
              <Box textAlign="center" mt={20}>
                <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                  No Data present
                </Typography>
              </Box>
            </>}
        </Box>
      )}
      </Box>
    </>
  )
}

export default TanClientMycas;